import { useMemo } from 'react';

import { checkIsValidJSON } from '@/services/helpers/checkIsValidJSON';

import type { TEurasV2BankOffer } from '../../../types/euras-v2.types';

interface IProps {
  bankOffer: TEurasV2BankOffer;
  offerDetailsModal: boolean | string;
}

const useAdditionalHelpers = ({ bankOffer, offerDetailsModal }: IProps) => {
  const additionalProducts = useMemo(() => {
    const products = {
      title: 'Доп. продукты',
      content: [] as string[]
    };

    if (bankOffer.productInfo && typeof bankOffer.productInfo === 'object') {
      if (bankOffer.productInfo.additionalProducts?.length) {
        products.content.push(...bankOffer.productInfo.additionalProducts);
      } else if (
        bankOffer.productInfo.current_value ||
        bankOffer.productInfo.product?.loan_period
      ) {
        products.content.push(
          `КАСКО ${
            bankOffer.productInfo.current_value
              ? JSON.parse(bankOffer.productInfo.current_value).loan_period
              : bankOffer.productInfo.product?.loan_period
                ? bankOffer.productInfo.product.loan_period
                : ''
          }`
        );
      }
    }

    return products;
  }, [bankOffer.productInfo]);

  const getDescription = () => {
    const description = bankOffer.bankDescription || '';
    const isValidJSON = checkIsValidJSON(description);
    const parsedJSON =
      isValidJSON && JSON.stringify(JSON.parse(description), null, 2);

    return typeof offerDetailsModal === 'string'
      ? offerDetailsModal
      : parsedJSON || description;
  };

  return { additionalProducts, getDescription };
};

export default useAdditionalHelpers;
